__turbopack_context__.v({
  "all": "JgDBsq_all",
  "all2": "JgDBsq_all2",
  "all3": "JgDBsq_all3",
  "col11": "JgDBsq_col11",
  "col12": "JgDBsq_col12",
  "col2": "JgDBsq_col2",
  "col3": "JgDBsq_col3",
  "col4": "JgDBsq_col4",
  "col8": "JgDBsq_col8",
  "desktop": "JgDBsq_desktop",
  "featuresCard___1Lfov": "JgDBsq_featuresCard___1Lfov",
  "featuresCard__iLFoq": "JgDBsq_featuresCard__iLFoq",
  "featuresCard__kRyFu": "JgDBsq_featuresCard__kRyFu",
  "featuresCard__lzu59": "JgDBsq_featuresCard__lzu59",
  "featuresCard__oTfD8": "JgDBsq_featuresCard__oTfD8",
  "featuresCard__q91K": "JgDBsq_featuresCard__q91K",
  "featuresCard__rc1RL": "JgDBsq_featuresCard__rc1RL",
  "featuresCard__tcaiM": "JgDBsq_featuresCard__tcaiM",
  "featuresCard__uNYO": "JgDBsq_featuresCard__uNYO",
  "featuresCard__wrdlL": "JgDBsq_featuresCard__wrdlL",
  "featuresCard__zkku5": "JgDBsq_featuresCard__zkku5",
  "featuresProductHeader__cPgn7": "JgDBsq_featuresProductHeader__cPgn7",
  "featuresProductHeader__ehMFb": "JgDBsq_featuresProductHeader__ehMFb",
  "featuresProductHeader__x8Z7J": "JgDBsq_featuresProductHeader__x8Z7J",
  "freeBox": "JgDBsq_freeBox",
  "h2__nqFlM": "JgDBsq_h2__nqFlM",
  "h2__otjU9": "JgDBsq_h2__otjU9",
  "h2__sMr9T": "JgDBsq_h2__sMr9T",
  "header": "JgDBsq_header",
  "header2": "JgDBsq_header2",
  "header3": "JgDBsq_header3",
  "header4": "JgDBsq_header4",
  "img___5Lo60": "JgDBsq_img___5Lo60",
  "img__a2WLz": "JgDBsq_img__a2WLz",
  "img__g2Tqp": "JgDBsq_img__g2Tqp",
  "img__gm9T": "JgDBsq_img__gm9T",
  "img__h5Aa5": "JgDBsq_img__h5Aa5",
  "img__lkexR": "JgDBsq_img__lkexR",
  "img__pKzWr": "JgDBsq_img__pKzWr",
  "img__psg6X": "JgDBsq_img__psg6X",
  "img__tzgMf": "JgDBsq_img__tzgMf",
  "img__wc9Sv": "JgDBsq_img__wc9Sv",
  "img__zaPcr": "JgDBsq_img__zaPcr",
  "img__zyQw": "JgDBsq_img__zyQw",
  "key2": "JgDBsq_key2",
  "key3": "JgDBsq_key3",
  "key4": "JgDBsq_key4",
  "list": "JgDBsq_list",
  "list11": "JgDBsq_list11",
  "list12": "JgDBsq_list12",
  "list13": "JgDBsq_list13",
  "list2": "JgDBsq_list2",
  "list3": "JgDBsq_list3",
  "list4": "JgDBsq_list4",
  "list5": "JgDBsq_list5",
  "list6": "JgDBsq_list6",
  "listItem___1KcAb": "JgDBsq_listItem___1KcAb",
  "listItem___89Uvc": "JgDBsq_listItem___89Uvc",
  "listItem___9VHxw": "JgDBsq_listItem___9VHxw",
  "listItem__aByf3": "JgDBsq_listItem__aByf3",
  "listItem__cTnb": "JgDBsq_listItem__cTnb",
  "listItem__hoXv8": "JgDBsq_listItem__hoXv8",
  "logo__doSz7": "JgDBsq_logo__doSz7",
  "logo__odhtj": "JgDBsq_logo__odhtj",
  "logo__yxrkp": "JgDBsq_logo__yxrkp",
  "mobile": "JgDBsq_mobile",
  "myCme": "JgDBsq_myCme",
  "row": "JgDBsq_row",
  "row2": "JgDBsq_row2",
  "row6": "JgDBsq_row6",
  "row7": "JgDBsq_row7",
  "row8": "JgDBsq_row8",
  "section2": "JgDBsq_section2",
  "section7": "JgDBsq_section7",
  "section8": "JgDBsq_section8",
  "sections": "JgDBsq_sections",
  "sections4": "JgDBsq_sections4",
  "sections5": "JgDBsq_sections5",
  "svg___2Ejme": "JgDBsq_svg___2Ejme",
  "svg___2VmpS": "JgDBsq_svg___2VmpS",
  "svg__ddtn6": "JgDBsq_svg__ddtn6",
  "svg__pCSx": "JgDBsq_svg__pCSx",
  "svg__sBle": "JgDBsq_svg__sBle",
  "svg__uzeLw": "JgDBsq_svg__uzeLw",
  "tablet": "JgDBsq_tablet",
  "title": "JgDBsq_title",
  "title2": "JgDBsq_title2",
  "title3": "JgDBsq_title3",
});
